import PropTypes from "prop-types";
import cn from "classnames";

export function Marker({ className = "", color = "bg-blue", index }) {
  return (
    <div
      className={cn(
        "relative w-12 h-12 rounded-marker flex items-center justify-center drop-shadow border-4 border-white text-lg text-white font-semibold -translate-x-1/2 -translate-y-full -rotate-45",
        color,
        className
      )}
    >
      <span className="rotate-45">{index}</span>
    </div>
  );
}

Marker.propTypes = {
  index: PropTypes.number.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
};
